// Residence Module Types

export enum UnitType {
  APARTMENT = 'APARTMENT',
  HOUSE = 'HOUSE'
}

export interface Unit {
  id: string;
  type: UnitType;
  name: string;
  tower?: string;
  floor?: string;
  number?: string;
  street?: string;
  exteriorNumber?: string;
  interiorNumber?: string;
  block?: string;
  sectionId?: string | null;
}
